import React, { useState } from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../Header/PublicHeader';
import Footer from '../Footer';

// Dummy data remains exactly the same
const dummyData = {
  webinars: [
    { title: 'Modern Techniques in Data Science', date: 'Jan 25, 2025' },
    { title: 'Leadership Skills Workshop', date: 'Feb 10, 2025' },
    { title: 'AI in Healthcare', date: 'Mar 5, 2025' },
    { title: 'Effective Communication Strategies', date: 'Apr 15, 2025' },
    { title: 'Financial Management for Nonprofits', date: 'May 20, 2025' },
    { title: 'Introduction to Cybersecurity', date: 'Jun 10, 2025' },
    { title: 'Project Management Essentials', date: 'Jul 22, 2025' },
    { title: 'Marketing Strategies for Small Businesses', date: 'Aug 18, 2025' },
    { title: 'Financial Management for Nonprofits', date: 'May 20, 2025' },
    { title: 'Introduction to Cybersecurity', date: 'Jun 10, 2025' },
    { title: 'Project Management Essentials', date: 'Jul 22, 2025' },
    { title: 'Marketing Strategies for Small Businesses', date: 'Aug 18, 2025' },
    { title: 'Financial Management for Nonprofits', date: 'May 20, 2025' },
    { title: 'Introduction to Cybersecurity', date: 'Jun 10, 2025' },
    { title: 'Project Management Essentials', date: 'Jul 22, 2025' },
  ],
  publications: [
    { title: 'Annual Research Report 2024' },
    { title: 'Industry Insights - Q1 2025' },
    { title: 'Whitepaper on Cloud Computing' },
    { title: 'The Future of AI' },
    { title: 'Sustainable Business Practices' },
    { title: 'Emerging Trends in Technology' },
    { title: 'Global Economic Outlook 2025' },
    { title: 'Case Studies in Innovation' },
    { title: 'Sustainable Business Practices' },
    { title: 'Emerging Trends in Technology' },
    { title: 'Global Economic Outlook 2025' },
    { title: 'Case Studies in Innovation' },
    { title: 'Sustainable Business Practices' },
    { title: 'Emerging Trends in Technology' },
    { title: 'Global Economic Outlook 2025' },
  ],
  recordings: [
    { title: 'Advanced Analytics Webinar', date: 'Dec 2024' },
    { title: 'Leadership Skills Workshop', date: 'Nov 2024' },
    { title: 'Cybersecurity Essentials', date: 'Oct 2024' },
    { title: 'Project Management Best Practices', date: 'Sep 2024' },
    { title: 'Data Privacy Regulations', date: 'Aug 2024' },
    { title: 'Building Effective Teams', date: 'Jul 2024' },
    { title: 'Digital Transformation Strategies', date: 'Jun 2024' },
    { title: 'Negotiation Skills for Leaders', date: 'May 2024' },
    { title: 'Data Privacy Regulations', date: 'Aug 2024' },
    { title: 'Building Effective Teams', date: 'Jul 2024' },
    { title: 'Digital Transformation Strategies', date: 'Jun 2024' },
    { title: 'Negotiation Skills for Leaders', date: 'May 2024' },
    { title: 'Data Privacy Regulations', date: 'Aug 2024' },
    { title: 'Building Effective Teams', date: 'Jul 2024' },
    { title: 'Digital Transformation Strategies', date: 'Jun 2024' },
  ],
  skillBuilding: [
    { title: 'Leadership Development Program' },
    { title: 'Technical Skill Building Workshops' },
    { title: 'NEP Certified Courses' },
    { title: 'Soft Skills Enhancement Program' },
    { title: 'Advanced Problem-Solving Techniques' },
    { title: 'Creative Thinking and Innovation' },
    { title: 'Time Management and Productivity' },
    { title: 'Conflict Resolution Strategies' },
    { title: 'Advanced Problem-Solving Techniques' },
    { title: 'Creative Thinking and Innovation' },
    { title: 'Time Management and Productivity' },
    { title: 'Conflict Resolution Strategies' },
    { title: 'Advanced Problem-Solving Techniques' },
    { title: 'Creative Thinking and Innovation' },
    { title: 'Time Management and Productivity' },
  ],
};

const TrainingAndResources = () => {
  const [activeTab, setActiveTab] = useState('webinars');
  const navigate = useNavigate();

  const tabs = [
    { label: 'Webinars & Workshops', key: 'webinars' },
    { label: 'Publications & Research Tools', key: 'publications' },
    { label: 'Webinar Recordings', key: 'recordings' },
    { label: 'Skill-Building Programs', key: 'skillBuilding' },
  ];

  const renderTabContent = () => {
    const content = dummyData[activeTab];
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {content.map((item, index) => (
          <div key={index} className="relative p-6 bg-white rounded-lg shadow-lg border-l-3 border-transparent transition-all duration-300 ease-in-out 
          before:absolute before:top-0 before:left-0 before:h-full before:w-[4px] before:bg-[#0d73b9] before:rounded-l-lg before:content-[''] before:pointer-events-none">
            <h4 className="text-xl font-semibold mb-2 text-gray-800">{item.title}</h4>
            {item.date && <p className="text-gray-500 text-sm">{item.date}</p>}
          </div>
        ))}
      </div>
    );
  };

  const handleExploreBenefitsClick = () => {
    navigate('/membership'); // Navigate to membership page
  };

  return (
    <>
          <PublicHeader />

    <div className="mx-auto bg-gray-50 rounded-lg shadow-md">
      {/* Hero Section with responsive adjustments */}
      <div className="position-relative text-center bg-[#0d73b9] text-white py-5" 
           >
        <div className="container px-4"> {/* Added container and padding for mobile */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mx-auto"
            style={{ maxWidth: "800px" }}
          >
            <h1 className="display-4 fw-bold mb-4">
              Training & Resources
            </h1>
            <p className="lead mb-4 text-white px-3"> {/* Added padding for mobile */}
              Discover a range of educational resources and training opportunities. Explore both free and paid versions to enhance your skills and knowledge.
            </p>
            <button className="btn btn-light btn-lg" onClick={handleExploreBenefitsClick}>
              Explore Benefits <i className="bi bi-arrow-right ms-2"></i>
            </button>
          </motion.div>
        </div>
        <div className="position-absolute bottom-0 start-0 end-0 height-50 bg-gradient"></div>
      </div>

      {/* Tabs Section with responsive classes */}
      <div className="flex flex-wrap justify-center mb-8 space-x-0 space-y-2 md:space-x-6 md:space-y-0 pt-8 px-4"> 
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`w-full md:w-auto px-6 py-3 rounded-full font-medium text-lg transition duration-300 
              ${activeTab === tab.key ? 'bg-[#0d73b9] text-white shadow-xl' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Section */}
      <div className="container py-6 px-4"> 
        {renderTabContent()}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default TrainingAndResources;